import { render, staticRenderFns } from "./snBtn.vue?vue&type=template&id=34305596&scoped=true&"
import script from "./snBtn.vue?vue&type=script&lang=js&"
export * from "./snBtn.vue?vue&type=script&lang=js&"
import style0 from "./snBtn.vue?vue&type=style&index=0&id=34305596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34305596",
  null
  
)

export default component.exports